import configureStore from './configureStore';

export const store = configureStore(window.__INITIAL_STATE__);
